<template>
    <div class="flex justify-between">
        <h2 class="font-bold text-4xl dark:text-gray-200">
            {{ text }}
        </h2>
    </div>
</template>

<script>
export default {
    name: "GenericHeader",
    props: {
        text: {
            type: String,
            required: true,
        }
    },
}
</script>
